import { StreamData } from 'types/streamData'
import { RichMentionedUrl } from 'schemas/RichMentionedUrlSchema'
import MediaType from 'enums/MediaType'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const isMediaUrl = (url: RichMentionedUrl) =>
  url &&
  (url.mediaType === MediaType.IMAGE ||
    url.mediaType === MediaType.VIDEO ||
    url.mediaType === MediaType.AUDIO)

const extractMediaUrl = (urls: RichMentionedUrl[]): RichMentionedUrl[] => {
  if (!urls) {
    return []
  }
  return urls.filter((url) => isMediaUrl(url)).map((url) => url)
}

const mediaUrlsResolver: FieldResolver = (metadata: Metadata) =>
  ({ mediaUrls: extractMediaUrl(metadata.getMentionedUrls()!) } as StreamData)

export default mediaUrlsResolver
